export class CostReviewFireEnUsRetrofitConsiderations {
  systemComponentReuse!: number;
  exceptions!: string;
  existingSystemManufacturer!: string;
  existingSystemModel!: string;
  operationalDuringRetrofit!: number;
  sufficientSpaceToMount!: number;
  conditionsVerified!: number;
  existingWiringReused!: number;
  subcontractorIsAware!: number;
  wiringIsCompatible!: number;
  conduitOrRacewayReuse!: number;
  fireWatchRequired!: number;
  responsibleForComponent!: number;
  isRetrofitConsiderationsApplicable!: boolean;
}
